// extracted by mini-css-extract-plugin
export default {"root":"FloatingWindow_root__LdHB2","window-appear":"FloatingWindow_window-appear__z1kfo"};